import { render, staticRenderFns } from "./StartFresh.vue?vue&type=template&id=76134e2a&scoped=true&"
import script from "./StartFresh.vue?vue&type=script&lang=js&"
export * from "./StartFresh.vue?vue&type=script&lang=js&"
import style0 from "./StartFresh.vue?vue&type=style&index=0&id=76134e2a&scoped=true&lang=css&"
import style1 from "./StartFresh.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76134e2a",
  null
  
)

export default component.exports